<template>
  <div class="general">
    <container>
      <template v-slot:header>
        {{$ml.get(`General Information`)}}
      </template>
      <div class="content columns">
        <div class="a-column">
          <h3>{{$ml.get(`Country`)}}</h3>
          <p>{{ lab.country }}</p>
        </div>
        <div class="a-column">
          <h3>{{$ml.get(`Address`)}}</h3>
          <p>{{ lab.address }}</p>
        </div>
        <div class="a-column">
          <h3>{{$ml.get(`Phone`)}}</h3>
          <p>{{ lab.phone }}</p>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"

export default {
  props: {
    lab: Object
  },
  components: {
    Container
  }
}
</script>

<style lang="scss" scoped>
  .general {
    width: 100%;
    margin-bottom: 8px;

    .content {
      width: 100%;
      padding: 16px;
      // background-color: #fff;
      flex-grow: 1;
      &.columns {
        display: flex;
        flex-direction: row;
        .a-column {
          flex-basis: calc(33% - 16px);
          margin: 0 8px;
          color: #4C5056;
          h3 {
            margin: 0 0 12px 0;
            font-size: 13px;
            font-weight: 400;

          }
          p {
            margin: 0;
            font-weight: 500;
            font-size: 16px;
          }
        }
      }
    }
  }
</style>